import { Multiples } from "../../SIprefixe";
import { Unit, UnitBaseTypes } from "../../Units";

function KiloNewtonDividedByMetre() {
  let dividedby = "/";
  return (
    <>
      <Unit unit={UnitBaseTypes.newton} prefix={Multiples.kilo} />
      {dividedby}
      <Unit unit={UnitBaseTypes.metre} />
    </>
  );
}

export default KiloNewtonDividedByMetre;
